import { SvgIcon } from "@mui/material";
import React from "react";

export default function NotificationIcon({ ...props }) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="24"
        viewBox="0 0 20 24"
        fill="none"
        {...props}
      >
        <path
          d="M11.4279 1.5V2.4C14.6867 3.09516 17.1419 6.12187 17.1419 9.75V10.6313C17.1419 12.8391 17.9142 14.9625 19.307 16.6125L19.6373 17.0016C20.0123 17.4469 20.106 18.075 19.8739 18.6141C19.6418 19.1531 19.1329 19.5 18.5704 19.5H1.42848C0.86601 19.5 0.355815 19.1531 0.125381 18.6141C-0.105053 18.075 -0.0128705 17.4469 0.360859 17.0016L0.691912 16.6125C2.08648 14.9625 2.85697 12.8391 2.85697 10.6313V9.75C2.85697 6.12187 5.27202 3.09516 8.57094 2.4V1.5C8.57094 0.671719 9.2093 0 9.99943 0C10.7896 0 11.4279 0.671719 11.4279 1.5ZM9.99943 24C9.24055 24 8.51291 23.6859 7.97722 23.1234C7.44154 22.5609 7.14245 21.7547 7.14245 21H12.8564C12.8564 21.7547 12.5573 22.5609 12.0216 23.1234C11.486 23.6859 10.7181 24 9.99943 24Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}
